import {setLoadingStateDispatch} from "../context/LoadingContext";


export class LoadingHelper {
    constructor(loading) {
        this.loading = loading
    }

    show() {
        this.loading(setLoadingStateDispatch(true))
    }

    hide() {
        this.loading(setLoadingStateDispatch(false))
    }
}